import Siema from 'siema';

// @TODO => Написать два метода которые буду возвращать два флага: последний ли это слайд и первые ли это слайд
// Или по другому, есть ли еще слады для листания вперед или назад или нет

Siema.prototype.generateDots = function () {
	if (!this.config.dots) {
		return;
	}

	let dotsContainer = this.root.querySelector('[data-slider="dots"]');
	let slides = this.innerElements;
	this.dots = [];

	for (let i = 0; i < slides.length; i++) {
		const button = document.createElement('button');

		button.textContent = i;
		button.setAttribute('type', 'button');
		button.setAttribute('title', `${i + 1}/${slides.length}`);
		button.className = 'slider__dot';
		button.addEventListener('click', () => this.goTo(i));
		dotsContainer.appendChild(button);
		this.dots.push(button);
	}

	this.root.classList.add('has-dots');
};

Siema.prototype.generateArrows = function () {
	if (!this.config.arrows) {
		return;
	}

	let arrowsContainer = this.root.querySelector('[data-slider="arrows"]');
	let arrows = ['prev', 'next'];
	let title = {
		prev: arrowsContainer.dataset.prev || 'Previous slide',
		next: arrowsContainer.dataset.next || 'Next slide'
	};
	let innerMarkup = {
		prev: '<i class="svgi svgi--chevron-left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20"><path d="M10.873,17.982 L9.600,19.256 L0.001,9.655 L0.037,9.619 L0.001,9.583 L9.600,-0.017 L10.873,1.256 L2.510,9.619 L10.873,17.982 Z"/></svg></i>',
		next: '<i class="svgi svgi--chevron-right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20"><path d="M10.873,9.655 L1.273,19.256 L0.001,17.982 L8.364,9.619 L0.001,1.256 L1.273,-0.017 L10.873,9.583 L10.837,9.619 L10.873,9.655 Z"/></svg></i>'
	};

	arrows.forEach(arrow => {
		const button = document.createElement('button');
		// button.textContent = arrow;
		button.setAttribute('type', 'button');
		button.setAttribute('title', title[arrow]);
		button.className = `slider__arrow slider__arrow--${arrow}`;
		button.innerHTML = innerMarkup[arrow];
		button.addEventListener('click', () => {
			this[arrow]();
			// this.rewind();  // @TODO => NEEDS TO IMPLEMENT CORRECT LOGIC FOR REWIND OPTION
		});
		arrowsContainer.appendChild(button);
	});

	this.root.classList.add('has-arrows');
};

Siema.prototype.autoplay = function () {
	if (!this.config.autoplay) {
		return;
	}

	let interval = null;
	let interavalFn = () => {
		clearInterval(interval);

		interval = setInterval(() => {
			this.next();
		}, this.config.autoplayInterval || 3000);
	};

	interavalFn();

	if (this.config.stopOnHover) {
		this.selector.addEventListener('mouseover', () => {
			clearInterval(interval);
		});
		this.selector.addEventListener('mouseout', interavalFn);
	}
};

Siema.prototype.keyboardNav = function () {
	if (!this.config.keyboardNav) {
		return;
	}

	let action = e => {
		if (e.keyCode === 37) {
			// if it's left arrow key
			this.prev();
		} else if (e.keyCode === 39) {
			// if it's right arrow key
			this.next();
		}
	};
	this.selector.addEventListener('mouseover', function () {
		document.onkeydown = (e) => {
			action.call(this, e);
		};
	});
	this.selector.addEventListener('mouseout', function () {
		document.onkeydown = () => {};
	});
};

Siema.prototype.rewind = function () {
	let { loop, rewind } = this.config;
	if (!rewind) {
		return;
	}
	if (loop && rewind) {
		return;
	}
	// console.log(this.currentSlide, this.innerElements.length);
	if (this.currentSlide === this.innerElements.length - 1) {
		this.goTo(0);
	}
	if (this.currentSlide === 0) {
		this.goTo(this.innerElements.length - 1);
	}
};

Siema.prototype.setActive = function () {
	let slides = this.innerElements;
	for (let i = 0; i < slides.length; i++) {
		let slide = slides[i];
		slide.setAttribute('data-slide', i);
	}

	if (this.config.dots) {
		let dots = this.dots;
		for (let i = 0; i < dots.length; i++) {
			let dot = dots[i];
			dot.setAttribute('data-slide', i);
		}
	}

	this.updateActive();
};

Siema.prototype.updateActive = function () {
	if (this.inited) {
		let allLozad = this.selector.querySelectorAll(`[data-slide="${this.currentSlide}"], [data-slide="${(this.currentSlide < this.innerElements.length) ? this.currentSlide + 1 : 0}"]`);
		for (let i = 0; i < allLozad.length; i++) {
			let element = allLozad[i].getElementsByClassName('lozad');
			if (element.length) window.lazyLoad.triggerLoad(element[0]);
		}
	}

	let slides = this.innerElements;
	for (let i = 0; i < slides.length; i++) {
		let slide = slides[i];
		slide.classList.toggle('is-active', +slide.dataset.slide === this.currentSlide);
	}

	if (this.config.dots) {
		let dots = this.dots;
		for (let i = 0; i < dots.length; i++) {
			let dot = dots[i];
			dot.classList.toggle('is-active', +dot.dataset.slide === this.currentSlide);
		}
	}
};

Siema.prototype.printSlideIndexWithIndicator = function () {
	let currentSlide = this.currentSlide;
	let currentSelector = $(this.selector).find('[data-current]');
	let totalSelector = $(this.selector).find('[data-total]');
	if (currentSlide < 0) {
		currentSelector.html(this.innerElements.length + currentSlide + 1);
	} else {
		currentSelector.html(this.currentSlide + 1);
	}
	totalSelector.html(this.innerElements.length);
};

const triggerEvent = (element, event) => {
	let e = document.createEvent('HTMLEvents');
	e.initEvent(event, false, true);
	element.dispatchEvent(e);
};

/**
 * На вход передаем выборку (массив) чистых DOM елементов и инициализируем слайдеры
 * @param {Array} [sliders=[]] - массив слайдеров
 */
export default function (sliders = []) {
	window.sliderInstance = {};
	let config = window.projectConfig;
	let presetsList = config.plugin.slider.preset;
	for (const root of sliders) {
		let sliderStage = root.querySelector('[data-slider="stage"]');
		let sliderItems = sliderStage.children.length;

		if (!sliderItems) {
			continue;
		}

		let preset = root.dataset.slider.toLocaleLowerCase() || {};
		let currentPreset = presetsList[preset];

		/**
		 * Когда слайдов меньше, чем кол-во слайдов указанное в perPage, слайдер валится
		 * Поэтому лишние значения в объекте (если это объект) срезаем
		 */
		const perPageIsObject = currentPreset.perPage instanceof Object;

		if (perPageIsObject) {
			Object.keys(currentPreset.perPage).forEach((key, index) => {
				if (sliderItems < index + 1) {
					delete currentPreset.perPage[key];
				}
			});
		}

		let instance = new Siema(Object.assign({}, {
			// Default preset
			selector: sliderStage,
			duration: 200,
			easing: 'ease-out',
			perPage: 1,
			startIndex: 0,
			draggable: true,
			multipleDrag: true,
			threshold: 30,
			keyboardNav: true,
			dots: false, // custom option
			arrows: true, // custom option
			arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			loop: true,
			rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			autoplay: false, // custom option
			autoplayInterval: 3000, // custom option
			stopOnHover: true, // custom option
			rtl: false,
			onInit: function () {},
			onChange: function () {
				this.updateActive();
			}
		}, currentPreset));
		instance.root = root;
		instance.generateDots();
		instance.generateArrows();
		instance.setActive();
		instance.autoplay();
		instance.keyboardNav();
		// instance.rewind();
		root.classList.add('is-initialized');
		instance.inited = true;
		// window.sliderInstance[preset] = instance;
		// window.sliderInstance['building_view_gallery'].resizeHandler()

		window.addEventListener('resize', () => {
			root.classList.toggle('hide-controls', sliderItems <= instance.perPage);
		});
		$(document).on('currentSlideUpdated', () => {
			if (instance.root.dataset.slider === 'gallery') {
				instance.goTo(window.popupSlide);
			}
		});
	}

	$(document).on('popupSliderUpdate', () => {
		triggerEvent(window, 'resize');
	});

	triggerEvent(window, 'resize');
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/slider.js